import React from 'react';

import createSvgIcon from './hoc/createSvgIcon';

export default createSvgIcon(
  () => (
    <>
      <path d="M20 9.06086V11H16.0091C16.9182 12.9129 16.8727 17.9997 10.3455 17.9997C2.77273 18.0444 3.06364 12.1895 3.06364 12.1895L6.67273 12.2342C6.7 15.2466 9.54545 15.2466 10.1091 15.2108C10.6909 15.1661 12.8636 15.1751 13.0364 13.0834C13.1091 12.109 12.1091 11.5185 11.0182 11H0V9.06086H20ZM16.7364 5.38698L13.1182 5.36016C13.1182 5.36016 13.2727 2.88409 10.1364 2.87515C7 2.85727 7.27273 4.84171 7.27273 5.09199C7.27273 5.34228 7.58182 6.41003 10 7H4.28182C4.28182 7 1.10909 1.14995 8.85455 0.121974C16.7727 -0.950692 16.7545 5.40486 16.7364 5.38698Z" />{' '}
    </>
  ),
  'FormatStrikethrough',
  '0 0 24 18'
);
